<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'addticket'+(order?order.id:'')">
      <slot></slot>
    </span>
    <el-dialog top="0vh" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h2 style="text-align: center;margin-bottom:30px;">创建工单</h2>
      <Ticket :r="ticket" mode="createNew" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible"
      :ticketPriorities="ticketPriorities" :singleList="singleList" :ticketTypes="ticketTypes" :exceptionTypes="exceptionTypes"
      :expressList="expressList" :merchants="merchants" @submit="submitHandler"></Ticket>
      <div style="clear:both;"></div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST, FILE_HOST,SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
import Ticket from './TicketBody.vue'
let _ = require('lodash')

export default {
  name: 'AddTicket',
  components: {
    Ticket:Ticket,
  },
  props: ['order','ticketStatus','ticketPriorities','singleList'
  ,'ticketTypes','ticketVisible','merchants','expressList','exceptionTypes'],
  data() {
    return {
      ticket:{},
      isSubmitting:false,
      dialogFormVisible:false
    }
  },
  async mounted() {
    
  },
  methods: {
    show () {
      this.dialogFormVisible = true
      //this.$set(this.r,'topic','主题')
      //this.$set(this.r,'description','描述内容')
      this.ticket={
        subject:'',
        description:'',
        priority_id:this.ticketPriorities.filter(i=>i.name=='中')[0].id,
        type_id:'',
        assigned_to_group:'',
        assigned_to:'',
        order_no_list:this.order?[this.order.order_no]:[],
        visible_range_id:this.ticketVisible[0].id
        //order_exception_id_list:this.order && this.order.exception_list && this.order.exception_list.length?[this.order.exception_list[this.order.exception_list.length-1]]:[]
      }
    },
    async submitHandler(ticket){
      this.isSubmitting=true
      let p = JSON.parse(JSON.stringify(ticket))
      //params.order_exception_id_list=params.order_exception_id_list.map(i=>i.id)
      if(p.order_exception)
        p.order_exception_id_list=[p.order_exception]
      if(p.order_no)
        p.order_no_list=[p.order_no]
      if(p.merchant_id)
        p.merchant_id_list=[p.merchant_id]
      if(p.transport_company_id)
        p.transport_express_id_list=[p.transport_company_id]
      let res = await api.addTicket(this,p)
      this.isSubmitting=false
      if(res.body.status=='ok'){
        this.dialogFormVisible = false
        this.$store.commit('updateMessageDialog', {visible:true,message:'工单提交成功'})
        this.$emit('fetchTicket')
      }
    },
    async filterSearch(val){
      this.orders = []
      let mers=[];
      if(val){
        let query={}
        query.keyword_type=0
        query.keyword = val
        let res = await api.getSingleOrders(this, query)
        mers = res.body.result
      }
      
      mers.forEach(item => {
        this.orders.push({value:item.order_id,id:item.order_id})
      })
    },
    handleAutoSelect(){
      this.order = this.orders.find(i=>i.order_id == this.order_id)
      this.exceptions = this.order.exception_list
    },
    handleClear(){
      this.orders = []
      this.exceptions = []
    },
    async createTicket(index){
      this.$emit('updateMail',index)
    },   
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/orders/ticket/AddTicket.vue